import { connect } from 'react-redux';
import { DistributionList } from '../../../components/audience/distributions/DistributionList';
import { ActionCreators as DistributionContactActionCreators } from '../../../store/DistributionContactStore';
import { ActionCreators as DistributionFileActionCreators } from '../../../store/DistributionFileStore';
import { IApplicationState } from '../../../store/index';
import { ActionCreators as SurveyParticipantActionCreators } from '../../../store/SurveyParticipantStore';

export const DistributionListContainer = connect(
	(state: IApplicationState, props: { surveyId: number; audienceId: number }) => ({
		...state.distributionList,
		...state.distributionContacts,
		...state.surveyParticipants,
		accessCodeType: state.audienceDetails.audience.accessCodeType,
		distributionType: state.audienceDetails.audience.distributionType,
		externalApplicationType: state.survey.surveyEditModel.survey.externalApplicationType,
		ssoAttributeId: state.audienceDetails.audience.ssoAttributeId,
		...props,
	}),
	{ ...DistributionFileActionCreators, ...DistributionContactActionCreators, ...SurveyParticipantActionCreators },
)(DistributionList as any) as any;
